// Workflow engine client (/api/workflows).
//
// Mirrors backend/apis/workflows.py. Definitions are versioned by copy: a
// published workflow is immutable, so editing means createDraft() -> save() ->
// publish(), and publish swaps the live one for its whole domain atomically.

import { get, post, put, del, AI_TIMEOUT_MS } from "./http";

export const listWorkflows = (params = {}) => get("/workflows", { query: params });
export const getWorkflow = (id) => get(`/workflows/${id}`);
export const createWorkflow = (body) => post("/workflows", body);
export const saveWorkflow = (id, body) => put(`/workflows/${id}`, body);
export const createDraft = (id, actor = "System") => post(`/workflows/${id}/draft`, { actor });
export const publishWorkflow = (id, actor = "System") => post(`/workflows/${id}/publish`, { actor });
export const deleteWorkflow = (id) => del(`/workflows/${id}`);

/** Node types, automation actions and the fields each domain may branch on. */
export const getPalette = () => get("/workflows/palette");

/** The directory work can be assigned to (people, roles, groups). */
export const getActors = () => get("/workflows/actors");

/** Structural check on an unsaved canvas. Errors block publishing, warnings don't. */
export const validateGraph = (graph) => post("/workflows/validate", { graph });

/** Walk a record through a graph and report every hop and why.
 *  Pass entityId to run a real demand through an unsaved canvas. */
export const simulate = (body) => post("/workflows/simulate", body, { timeout: AI_TIMEOUT_MS });

/** The live workflow for a domain — what every non-admin screen should draw. */
export const getActive = (domain) => get(`/workflows/active/${domain}`);

/** Install or reinstall the shipped workflows. */
export const seedOotb = (force = false) => post("/workflows/seed", { force, actor: "System" });

export const listInstances = (params = {}) => get("/workflows/instances", { query: params });
